module.exports = __webpack_public_path__ + "img/paper-7.f560cabc.png";